import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  DialogContent,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  TextField
} from "@mui/material";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as SelectedCheckBox } from "assets/SelectedCheckBox.svg";
import { ReactComponent as UnChecked } from "assets/UnChecked.svg";
import { ReactComponent as SearchIcon } from "assets/searchicon.svg";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { useTranslate } from "hooks/useTranslate";
import _, { cloneDeep } from "lodash";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { ResItem } from "../Filters/Filters";
import {
  fetchCorpSavedFilters,
  fetchManagementcOInfo,
  fetchOwnerInfo,
  saveDefaultFilters
} from "../Filters/Filters.slice";
import Typography from "../Typography";
import SelectedPlansList from "../plans/SelectedPlansList";

import React, { useEffect, useRef, useState } from "react";
import Spinner from "../Spinner/Spinner";
import "./index.scss";
interface NavTabContentProps {
  filters: ResItem[];
  handleSetCategory: (val: string) => void;
  selectedFilterCategory: string;
  updateFilterOptions: (key: string, id: number, addValue: string, booleanValue: boolean, name: string) => void;
  checkedValue: any;
  toggleAccordion: (cou: string) => void;
  accordionState: any;
  setSelectedAccordian: (val: string) => void;
  selectedAccordian: string;
  isOpenCorpWizard: boolean;
}

const NavTabContent: React.FC<NavTabContentProps> = ({
  filters,
  handleSetCategory,
  selectedFilterCategory,
  updateFilterOptions,
  checkedValue,
  toggleAccordion,
  accordionState,
  setSelectedAccordian,
  selectedAccordian,
  isOpenCorpWizard
}) => {
  const dispatch = useAppDispatch();
  const rightContentRef = useRef<HTMLDivElement>(null);
  const [searchText, setSearchText] = useState<string>("");
  const [managementData, setManagementData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const translate = useTranslate();

  const handleCloseDialog = async () => {
    const filters = cloneDeep(checkedValue);
    const modifiedFilters = filters.map(({ name, ...rest }: any) => rest);
    const jsonData = {
      default: [
        {
          filters: modifiedFilters
        }
      ]
    };
    await dispatch(saveDefaultFilters(jsonData));
    await dispatch(
      fetchCorpSavedFilters({ types: ["default", "dynamic", "static", "bookmarked"], isModalClose: true })
    );
  };

  const scrollToTop = () => {
    if (rightContentRef.current) {
      rightContentRef.current.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  const selectedCategoryFilters = () => {
    const selectedCatFilt = filters.find((filter) => filter.key === selectedFilterCategory);
    return selectedCatFilt;
  };

  const returnSelectedCategory = (key: string) => {
    const selectedVal = checkedValue.findIndex((val: any) => val.key === key);
    return checkedValue[selectedVal];
  };

  const getFilterByKey = (key: string) => {
    const index = checkedValue.findIndex((val: any) => val.key === key);
    return checkedValue[index];
  };

  const selectedAllValue = () => {
    const transformedData = checkedValue.reduce((acc: any, item: any) => {
      const { id, options, name, key } = item;
      const transformedOptions = options.map((option: string) => ({ key, id, option, name }));
      return [...acc, ...transformedOptions];
    }, []);
    return transformedData;
  };

  const getCountOfSelectedFilter = (key: string) => {
    const selectedValIndex = checkedValue.findIndex((val: any) => val.key === key);
    if (selectedValIndex > -1) {
      const optionsCount = checkedValue[selectedValIndex]?.options?.length;
      return optionsCount;
    }
    return 0;
  };

  const LeftContent = () => {
    return (
      <div className="left-content-container">
        <div className="tab-heading">
          <Typography variant="body2">Filters</Typography>
        </div>
        <div className="abcdc">
          {filters.map((filter) => {
            const count = getCountOfSelectedFilter(filter.key);
            if (filter.wizardDisplay !== "Y") return <div></div>;
            return (
              <div
                className={`tab-sub-heading ${selectedFilterCategory === filter.key ? "selected-category" : ""}`}
                key={filter.key}
                onClick={() => {
                  if (searchText) {
                    setSearchText("");
                  }
                  scrollToTop();
                  handleSetCategory(filter.key);
                }}
              >
                <div className="category-name">
                  <Typography variant="body2" showBold color={tokens.Text.General.PrimaryBody}>
                    {filter.name}
                  </Typography>
                  {count && count > 0 ? (
                    <Typography variant="body2" color={tokens.Text.General.PrimaryBody}>
                      ({count})
                    </Typography>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const interateKey = (filters: any) => {
    if (searchText.length > 2) {
      if (isSearchVisible) {
        return managementData;
      }
    }
    return filters;
  };

  const RightContent = () => {
    const tabData = selectedCategoryFilters();
    if (!tabData) return <div></div>;
    const selectedCat = returnSelectedCategory(tabData?.key);

    const filter = interateKey(tabData.filters);
    return (
      <div className="right-content-container" ref={rightContentRef}>
        {filter?.map((data: any) => {
          const isString = typeof data === "string";
          const value = !isString ? data.value : data;
          const getKey = !isString ? data.key : data;
          const stringWithoutSpaces = value.replace(/\s/g, "");
          const dynamicKey = `${tabData.key}-${stringWithoutSpaces}`;
          return (
            <div className="right-container" key={_.uniqueId(dynamicKey)}>
              <FormGroup>
                <FormControlLabel
                  className="check-box-container"
                  control={
                    <Checkbox
                      icon={<UnChecked />}
                      checkedIcon={<SelectedCheckBox />}
                      checked={selectedCat ? selectedCat?.options?.includes(getKey) : false}
                      onChange={(e: any) => {
                        const element = e.target;
                        updateFilterOptions(tabData.key, tabData.id, getKey, element.checked, tabData.name);
                      }}
                    />
                  }
                  label={value}
                />
              </FormGroup>
            </div>
          );
        })}
      </div>
    );
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setSearchText("");
    if (isExpanded) {
      toggleAccordion(panel);
      setSelectedAccordian(panel);
    } else {
      toggleAccordion("");
      setSelectedAccordian("");
    }
  };

  const getPlaceHolder = () => {
    if (selectedFilterCategory === "ownerGroup" || selectedAccordian === "ownerGroup") {
      return "Search Owner Group";
    } else if (selectedFilterCategory === "managementCompany" || selectedAccordian === "managementCompany") {
      return "Search Management Co.";
    }
    return "";
  };

  const MobileView = () => {
    return (
      <div className="mobile-design-wrapper">
        <div className="filter-text">
          <Typography variant="body2">Filters</Typography>
        </div>
        {filters.map((data) => {
          const selectedOptions = getFilterByKey(data.key)?.options;
          if (data.wizardDisplay !== "Y") return <div></div>;
          const filter = interateKey(data?.filters);
          return (
            <Accordion
              className={`mobile-tab-accordian ${selectedAccordian === data.key ? "selected-accordian" : ""} `}
              key={data.name}
              onChange={handleChange(data.key)}
              expanded={accordionState === data.key}
            >
              <AccordionSummary expandIcon={<ArrowDown />} className="mobile-tab-summary">
                <Typography>
                  <Typography variant="body2" showBold>
                    {data.name}
                  </Typography>
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="filter-accordian-details">
                {filter?.map((option: any) => {
                  const isString = typeof option === "string";
                  const dynamicKey = `${selectedFilterCategory}-${isString ? option : option.value}`;
                  const value = !isString ? option.value : option;
                  const getKey = !isString ? option.key : option;
                  return (
                    <div className="filter-list" key={dynamicKey}>
                      <FormGroup>
                        <FormControlLabel
                          className="filter-control-label"
                          control={
                            <Checkbox
                              onChange={(e: any) => {
                                const element = e.target;
                                updateFilterOptions(data.key, data.id, getKey, element.checked, data.name);
                              }}
                              checked={selectedOptions ? selectedOptions?.includes(getKey) : false}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              color={tokens.Text.General.PrimaryHeadline}
                              className="ellipse-one"
                            >
                              {value}
                            </Typography>
                          }
                        />
                      </FormGroup>
                    </div>
                  );
                })}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    );
  };

  const handleSearchChange = (event: any) => {
    setSearchText(event.target.value);
  };

  const debouncedFetchGlobalData = _.debounce(async () => {
    if (searchText.length > 2) {
      setIsLoading(true);
      if (selectedFilterCategory === "managementCompany" || selectedAccordian === "managementCompany") {
        const res: any = await dispatch(fetchManagementcOInfo(searchText));
        const { status, ...args } = res.payload;
        const response = Object.values(args);
        setManagementData(response);
      } else if (selectedFilterCategory === "ownerGroup" || selectedAccordian === "ownerGroup") {
        const res: any = await dispatch(fetchOwnerInfo(searchText));
        const { status, ...args } = res.payload;
        const response = Object.values(args);
        setManagementData(response);
      }
      setIsLoading(false);
    }
  }, 300);

  useEffect(() => {
    debouncedFetchGlobalData();

    return () => {
      debouncedFetchGlobalData.cancel();
    };
  }, [searchText]);

  const selectedFilterText = selectedAllValue().length
    ? `${selectedAllValue().length} selected`
    : translate("common.no.filter.selected");

  const isSearchVisible =
    selectedFilterCategory === "ownerGroup" ||
    selectedFilterCategory === "managementCompany" ||
    selectedAccordian === "managementCompany" ||
    selectedAccordian === "ownerGroup";

  return (
    <div className="nav-tab-component">
      {isOpenCorpWizard && (
        <DialogFormation
          openDialog={isOpenCorpWizard}
          handleClose={() => {}}
          contentClass="corp-wizard-dialog"
          isCrossShow={false}
          subTitle={translate("dashboard.wizard.corp.subHeading")}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button disabled={!checkedValue.length} label="Submit" onClick={handleCloseDialog} />
            </div>
          }
          title={translate("dashboard.wizard.corp")}
        >
          <DialogContent>
            <div className="nav-tab-component">
              {isLoading && <Spinner backdropVisible />}
              <div className="search-component">
                <div className="search-box">
                  {isSearchVisible && (
                    <TextField
                      placeholder={getPlaceHolder()}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        )
                      }}
                      value={searchText}
                      onChange={handleSearchChange}
                    />
                  )}
                </div>
                <div className="multi-select">
                  <SelectedPlansList
                    allFilters={filters}
                    options={selectedAllValue()}
                    handleChange={(option: any) => {
                      updateFilterOptions(option.key, option.id, option.option, false, option.name);
                    }}
                    transformOrigin={{ horizontal: "left", vertical: "top" }}
                    isPlan={false}
                    label={
                      <Typography variant="body2" color={tokens.Text.General.Secondary} showBold>
                        {selectedFilterText}
                      </Typography>
                    }
                  />
                </div>
              </div>
              <div className="content-container">
                <div className="mobile-design-container">{MobileView()}</div>
                <div className="content-wrapper">
                  <div className="left-side-wrapper">{LeftContent()}</div>
                  <div className="right-side-wrapper">{RightContent()}</div>
                </div>
              </div>
            </div>
          </DialogContent>
        </DialogFormation>
      )}
    </div>
  );
};

export default React.memo(NavTabContent);
